import { writable } from 'svelte/store';
import type { CharityDonationRequest } from '../api/charityServices/charity-donation-request.service';

// Create a writable store with initial value of null
export const currentDonationRequest = writable<CharityDonationRequest | null>(null);

// Helper functions for setting and clearing the current donation
export function setCurrentDonation(donation: CharityDonationRequest) {
  currentDonationRequest.set(donation);
}

export function clearCurrentDonation() {
  currentDonationRequest.set(null);
} 